import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'OwnerSearch',
})
export class OwnerSearchPipe implements PipeTransform {
  constructor() {}

  transform(items: Array<any>, keyword: string, activeType: string, passType: string): Array<any> {
    // 키워드가 있을 때
    if (keyword && items && activeType && passType) {
      if (activeType == '회원 상태 전체' && passType == '승인 상태 전체') {
        return items.filter(ele => {
          return ele.shopId?.owner.indexOf(keyword) > -1 || ele.email.indexOf(keyword) > -1 || ele.shopId?.shopName.indexOf(keyword) > -1;
        });
      }
      if (activeType != '회원 상태 전체' && passType == '승인 상태 전체') {
        switch (activeType) {
          case '일반': {
            const uniqItems = items.filter(member => !member.suspendSwitch && !member.exitSwitch);
            return uniqItems.filter(ele => {
              return ele.shopId?.owner.indexOf(keyword) > -1 || ele.email.indexOf(keyword) > -1 || ele.shopId?.shopName.indexOf(keyword) > -1;
            });
          }
          case '정지': {
            const uniqItems = items.filter(member => member.suspendSwitch);
            return uniqItems.filter(ele => {
              return ele.shopId?.owner.indexOf(keyword) > -1 || ele.email.indexOf(keyword) > -1 || ele.shopId?.shopName.indexOf(keyword) > -1;
            });
          }
          case '탈퇴': {
            const uniqItems = items.filter(member => member.exitSwitch);
            return uniqItems.filter(ele => {
              return ele.shopId?.owner.indexOf(keyword) > -1 || ele.email.indexOf(keyword) > -1 || ele.shopId?.shopName.indexOf(keyword) > -1;
            });
          }
        }
      }
      if (activeType == '회원 상태 전체' && passType != '승인 상태 전체') {
        switch (passType) {
          case '승인 전': {
            const uniqItems = items.filter(member => !member.passSwitch);
            return uniqItems.filter(ele => {
              return ele.shopId?.owner.indexOf(keyword) > -1 || ele.email.indexOf(keyword) > -1 || ele.shopId?.shopName.indexOf(keyword) > -1;
            });
          }
          case '승인 완료': {
            const uniqItems = items.filter(member => member.passSwitch);
            return uniqItems.filter(ele => {
              return ele.shopId?.owner.indexOf(keyword) > -1 || ele.email.indexOf(keyword) > -1 || ele.shopId?.shopName.indexOf(keyword) > -1;
            });
          }
        }
      }

      if (activeType == '회원 상태 전체' && passType != '승인 상태 전체') {
        switch (passType) {
          case '승인 전': {
            const uniqItems = items.filter(member => !member.passSwitch);
            return uniqItems.filter(ele => {
              return ele.shopId?.owner.indexOf(keyword) > -1 || ele.email.indexOf(keyword) > -1 || ele.shopId?.shopName.indexOf(keyword) > -1;
            });
          }
          case '승인 완료': {
            const uniqItems = items.filter(member => member.passSwitch);
            return uniqItems.filter(ele => {
              return ele.shopId?.owner.indexOf(keyword) > -1 || ele.email.indexOf(keyword) > -1 || ele.shopId?.shopName.indexOf(keyword) > -1;
            });
          }
        }
      }

      if (activeType != '회원 상태 전체' && passType != '승인 상태 전체') {
        switch (activeType) {
          case '일반': {
            let uniqItems = items.filter(member => !member.suspendSwitch && !member.exitSwitch);
            if (passType == '승인 전') {
              uniqItems = uniqItems.filter(member => !member.passSwitch);

              return uniqItems.filter(ele => {
                return ele.shopId?.owner.indexOf(keyword) > -1 || ele.email.indexOf(keyword) > -1 || ele.shopId?.shopName.indexOf(keyword) > -1;
              });
            }
            if (passType == '승인 완료') {
              uniqItems.filter(member => member.passSwitch);
              return uniqItems.filter(ele => {
                return ele.shopId?.owner.indexOf(keyword) > -1 || ele.email.indexOf(keyword) > -1 || ele.shopId?.shopName.indexOf(keyword) > -1;
              });
            }
          }
          case '정지': {
            let uniqItems = items.filter(member => member.suspendSwitch);
            if (passType == '승인 전') {
              uniqItems = uniqItems.filter(member => !member.passSwitch);

              return uniqItems.filter(ele => {
                return ele.shopId?.owner.indexOf(keyword) > -1 || ele.email.indexOf(keyword) > -1 || ele.shopId?.shopName.indexOf(keyword) > -1;
              });
            }
            if (passType == '승인 완료') {
              uniqItems.filter(member => member.passSwitch);
              return uniqItems.filter(ele => {
                return ele.shopId?.owner.indexOf(keyword) > -1 || ele.email.indexOf(keyword) > -1 || ele.shopId?.shopName.indexOf(keyword) > -1;
              });
            }
          }
          case '탈퇴': {
            let uniqItems = items.filter(member => member.exitSwitch);
            if (passType == '승인 전') {
              uniqItems = uniqItems.filter(member => !member.passSwitch);

              return uniqItems.filter(ele => {
                return ele.shopId?.owner.indexOf(keyword) > -1 || ele.email.indexOf(keyword) > -1 || ele.shopId?.shopName.indexOf(keyword) > -1;
              });
            }
            if (passType == '승인 완료') {
              uniqItems.filter(member => member.passSwitch);
              return uniqItems.filter(ele => {
                return ele.shopId?.owner.indexOf(keyword) > -1 || ele.email.indexOf(keyword) > -1 || ele.shopId?.shopName.indexOf(keyword) > -1;
              });
            }
          }
        }
      }
    }
    // 키워드가 없을 때
    if (!keyword && items && activeType && passType) {
      if (activeType == '회원 상태 전체' && passType == '승인 상태 전체') {
        return items;
      }
      if (activeType != '회원 상태 전체' && passType == '승인 상태 전체') {
        switch (activeType) {
          case '일반': {
            return items.filter(member => !member.suspendSwitch && !member.exitSwitch);
          }
          case '정지': {
            return items.filter(member => member.suspendSwitch);
          }
          case '탈퇴': {
            return items.filter(member => member.exitSwitch);
          }
        }
      }
      if (activeType == '회원 상태 전체' && passType != '승인 상태 전체') {
        switch (passType) {
          case '승인 전': {
            return items.filter(member => !member.passSwitch);
          }
          case '승인 완료': {
            return items.filter(member => member.passSwitch);
          }
        }
      }

      if (activeType != '회원 상태 전체' && passType != '승인 상태 전체') {
        switch (activeType) {
          case '일반': {
            const uniqItems = items.filter(member => !member.suspendSwitch && !member.exitSwitch);
            if (passType == '승인 전') {
              return uniqItems.filter(member => !member.passSwitch);
            }
            if (passType == '승인 완료') {
              return uniqItems.filter(member => member.passSwitch);
            }
          }
          case '정지': {
            const uniqItems = items.filter(member => member.suspendSwitch);
            if (passType == '승인 전') {
              return uniqItems.filter(member => !member.passSwitch);
            }
            if (passType == '승인 완료') {
              return uniqItems.filter(member => member.passSwitch);
            }
          }
          case '탈퇴': {
            const uniqItems = items.filter(member => member.exitSwitch);
            if (passType == '승인 전') {
              return uniqItems.filter(member => !member.passSwitch);
            }
            if (passType == '승인 완료') {
              return uniqItems.filter(member => member.passSwitch);
            }
          }
        }
      }
    }
  }
}
